import { useDeepEqualValue } from '@superdispatch/hooks';
import { useResponsiveContext } from "../responsive/ResponsiveContext.js";
export function parseResponsiveProp(prop) {
  var _tablet, _desktop;
  if (typeof prop != 'object') return [prop, prop, prop];
  var [mobile, tablet, desktop] = prop;
  (_tablet = tablet) !== null && _tablet !== void 0 ? _tablet : tablet = mobile;
  (_desktop = desktop) !== null && _desktop !== void 0 ? _desktop : desktop = tablet;
  return [mobile, tablet, desktop];
}
export function useResponsiveProp(prop) {
  return useDeepEqualValue(parseResponsiveProp(prop));
}
export function useResponsiveValue(xs, sm) {
  var md = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : sm;
  var lg = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : md;
  var xl = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : lg;
  var {
    breakpoint = 'xs'
  } = useResponsiveContext();
  return {
    xs,
    sm,
    md,
    lg,
    xl
  }[breakpoint];
}
export function useResponsivePropRecord(prop) {
  if (typeof prop != 'object') prop = {
    xs: prop
  };
  var {
    xs,
    sm,
    md,
    lg,
    xl
  } = prop;
  return useResponsiveValue(xs, sm !== null && sm !== void 0 ? sm : xs, md, lg, xl);
}